import Drawer from "flowbite/lib/esm/components/drawer"
import OverlayBase from "./overlay_base"

// Delegated drawer controller — see overlay_base.js. Options are read from the
// drawer element (data-drawer-placement, data-drawer-backdrop,
// data-drawer-body-scrolling, data-drawer-edge).
export default class extends OverlayBase {
  _create(element, id) {
    return new Drawer(element, this._options(element), { id, override: true })
  }

  _options(element) {
    const {
      drawerPlacement: placement,
      drawerBackdrop: backdrop,
      drawerBodyScrolling: bodyScrolling,
      drawerEdge: edge,
    } = element.dataset
    return {
      ...(placement && { placement }),
      ...(backdrop !== undefined && { backdrop: backdrop !== "false" }),
      ...(bodyScrolling !== undefined && {
        bodyScrolling: bodyScrolling !== "false",
      }),
      ...(edge !== undefined && { edge: edge !== "false" }),
    }
  }
}
